export class CustomerHistory {
    constructor(customer_history) {
        this.checked_in_at  = customer_history.checked_in_at;
        this.checked_out_at = customer_history.checked_out_at;
        this.point_added    = customer_history.point_added;
        this.checked_out_by = customer_history.checked_out_by ? new CheckedOutBy(customer_history.checked_out_by) : null;
        this.staffs         = customer_history.staffs ? this.getStaff(customer_history.staffs) : [];
        this.services       = customer_history.services ? this.getService(customer_history.services) : [];
        this.checkin        = customer_history.checkin;
        this.checkout_staffs= customer_history.checkout_staffs;
    }

    getStaff(staffs) {
        let staff_arr = [];
        for(let i = 0; i < staffs.length; i++) {
            staff_arr.push(new Staff(staffs[i]));
        }
        return staff_arr;
    }

    getService(services) {
        let service_arr = [];
        for(let i = 0; i < services.length; i++) {
            service_arr.push(new Service(services[i]));
        }
        return service_arr;
    }
}

class Staff {
    constructor(staff) {
        this.name = staff.name;
    }
}

class Service {
    constructor(staff) {
        this.name = staff.name;
    }
}

class CheckedOutBy {
    constructor(data) {
        this.user_id    = data.user_id;
        this.name       = data.name;
        this.code       = data.code;
        this.created_at = data.created_at;
        this.updated_at = data.updated_at;
        this.color_code = data.color_code;
    }
}